/**
 * Why does this exist?
 * Just in case, for whatever reason, the frontend
 * fails to take a user offline when they sign out,
 * we'll automatically take them offline after 15 minutes.
 */
export const POLLING_INTERVAL = 1000 * 60 * 15;
export const POLLING_BUFFER = 1000 * 30;
